import React from "react";
import PropTypes from "prop-types";
import PriceFilterStyles from "./PriceFilter.styles";
import { TokenIcon } from "../../../../../assets/Icons";
import {
  PRICE_MAX,
  PRICE_MIN,
  PRICE_STEP
} from "../../../../../constants/filter.constants";
import { TwoThumbs } from "../../../../../components/range";
import {
  transformTokenCurrencyIcons,
  transformTokensToRsd
} from "../../../../../utils/transformTokensToRsd";


// Stops the user from entering the price larger than the preset maximum one
const ABS_MIN = transformTokensToRsd(PRICE_MIN);
const ABS_MAX = transformTokensToRsd(PRICE_MAX);

const clamp = (value, min, max) =>
  Math.min(Math.max(value, min), max);

const PriceFilter = ({ handlePriceChange, priceRange }) => {
  // Stops the user from entering the minimum price that's higher than the maximum one
  const handleMinChange = value => {
    let newMin = Number(value);
    if (isNaN(newMin)) return;

    newMin = clamp(newMin, ABS_MIN, ABS_MAX);
    newMin = Math.min(newMin, priceRange[1]);

    handlePriceChange([newMin, priceRange[1]]);
  };

  const handleMaxChange = value => {
    let newMax = Number(value);
    if (isNaN(newMax)) return;

    newMax = clamp(newMax, ABS_MIN, ABS_MAX);
    newMax = Math.max(newMax, priceRange[0]);

    handlePriceChange([priceRange[0], newMax]);
  };

  return (
    <PriceFilterStyles>
      <div className="inputWrapper">
        <div className="inputContainer">
          <label>{transformTokenCurrencyIcons()}</label>
          <input
            type="number"
            min={ABS_MIN}
            max={priceRange[1]}
            step={transformTokensToRsd(PRICE_STEP)}
            name="minPrice"
            value={priceRange[0]}
            onChange={e => handleMinChange(e.target.value)}
          />
        </div>
        <span>-</span>
        <div className="inputContainer">
          <label>{transformTokenCurrencyIcons()}</label>
          <input
            type="number"
            min={priceRange[0]}
            max={ABS_MAX}
            step={transformTokensToRsd(PRICE_STEP)}
            name="maxPrice"
            value={priceRange[1]}
            onChange={e => handleMaxChange(e.target.value)}
          />
        </div>
      </div>
      <TwoThumbs
        values={priceRange}
        onRangeChange={handlePriceChange}
        rtl={false}
      />
    </PriceFilterStyles>
  );
};

PriceFilter.propTypes = {
  handlePriceChange: PropTypes.func.isRequired,
  priceRange: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default PriceFilter;
